import { MdDateRange, MdDescription, MdNumbers } from "react-icons/md";
import styles from "../../../../../../styles/card_sacop_aditivo.module.css";
import { BiDetail } from "react-icons/bi";
import { GrCurrency, GrMoney } from "react-icons/gr";
import { LuSlidersVertical } from "react-icons/lu";

export default function CardSacopAditivo({ data }) {
  return (
    <section className={styles.card}>
      <div className={styles.details_container}>
        <div className={styles.div_1}>
          <h4> <BiDetail size={22} />Detalhes do Contrato</h4>
          <p><strong><MdNumbers size={20}/> Número:</strong> {data.NUMERO}</p>
          <p><strong><MdDateRange size={20}/> Data Início:</strong> {data.DATAINICIO !== "" ? data.DATAINICIO : "N/A"}</p>
          <p><strong><MdDateRange size={20}/> Data Fim:</strong> {data.DATAFIM !== "" ? data.DATAFIM : "N/A"}</p>
        </div>
        <div className={styles.div_2}>
          <h4><GrCurrency size={22} /> Valores</h4>
          <p><strong><GrMoney size={16}/> Valor Atualizado:</strong> R$ {data.VALORATUALIZADO}</p>
          <p><strong><GrMoney size={16}/> Valor Decrescido:</strong> R$ {data.VALORDECRESSIMO}</p>
          <p><strong><GrMoney size={16}/> Valor Acrescido:</strong> R$ {data.VALORACRESSIMO}</p>
          <p><strong><LuSlidersVertical size={16}/>Tipo Aditivo:</strong> {data.ADITIVOTIPO}</p>
        </div>
      </div>

      <div className={styles.div_description}>
        <h4><MdDescription size={20} /> Descrição</h4>
        <p>{data.DESCRICAO}</p>
      </div>

      <div className={styles.div_3}>
        <a
          href={`/licitacoes-e-contratos/detalhes/${data.ID}`}
          target="_self"
          className={styles.btn}
        >
          DETALHAR
        </a>
      </div>
    </section>
  );
}